import React from 'react';
import { packItems } from '../data/content';
import { Icon } from '../utils/icons';
export function WhatsInside() {
  const [featured, ...rest] = packItems;
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-199" data-mp="yto9uqjzo6kh">
      <div className="mx-auto max-w-4xl" data-id="element-200" data-mp="kvzpdjtu31fy">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-201" data-mp="pv2kabg3nra7">
          What&apos;s Inside the Volleyball Ready™ Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-202" data-mp="fwwlw3ti53a3">
          <li className="flex flex-col items-start gap-5 rounded-2xl bg-brand px-7 py-8 text-left sm:col-span-2 sm:flex-row sm:items-center sm:px-9" data-id="element-203" data-mp="fyg2jvj2lgce">
            <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-white/15 text-white" data-id="element-204" data-mp="741mhqqpu1s8">
              <Icon name={featured.icon} className="h-7 w-7" data-id="element-205" data-mp="3oe9jgbhbcttz" />
            </span>
            <div data-id="element-206" data-mp="3tazv8mm3539l">
              <h3 className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-207" data-mp="3tbjec6nh1xp7">
                {featured.title}
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/75" data-id="element-208" data-mp="37v34429872m2">
                {featured.text}
              </p>
            </div>
          </li>

          {rest.map(item => <li key={item.title} className="grid grid-rows-[auto_auto_1fr] rounded-2xl bg-sand px-6 py-8" data-id="element-209" data-mp="3hta6ng2rpi4j">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-210" data-mp="2u3y06nytro5x">
                <Icon name={item.icon} className="h-5 w-5" data-id="element-211" data-mp="2p666boemdrz3" />
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink sm:text-lg" data-id="element-212" data-mp="32xb1ad71lw33">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55 sm:text-sm" data-id="element-213" data-mp="2y36w9zhc7y4n">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}